import { useMemo } from 'react'
import { Permission, useStoresByPermissionQuery } from '../../../graphql'

export type UseDemandRequestStoresReturn = {
	/** Stores where user can edit demand requests */
	stores: { id: string, name: string }[],
	/** Whether user has permission for at least one store */
	hasPermission: boolean,
	/** Loading state */
	loading: boolean,
}

/**
 * Hook to get stores where the user has CAN_EDIT_DEMAND_REQUEST_BY_STORE_ID permission
 */
export function useDemandRequestStores(): UseDemandRequestStoresReturn {
	const { data, loading } = useStoresByPermissionQuery( {
		variables: {
			permissions: [ Permission.CanEditDemandRequestByStoreId ],
		},
		fetchPolicy: 'cache-first',
	} )

	const stores = useMemo( () => {
		return data?.stores?.map( ( store ) => ( {
			id: String( store.id ),
			name: store.name,
		} ) ) ?? []
	}, [ data ] )

	return {
		stores,
		hasPermission: stores.length > 0,
		loading,
	}
}
